export default __webpack_public_path__ + "static/media/svg-22.3d34b9c1.svg";